import { Tag, Wallet, CalendarClock, Gift, Home, MessageCircle } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";
import { waHref } from "@/lib/wa";

export default function Pricing({ content }) {
  const p = content.pricing;
  const cta = waHref(content);
  const items = [
    { icon: Tag, label: "Harga Mulai", value: p.priceStart, testId: "pricing-price" },
    { icon: Wallet, label: "DP Mulai", value: p.dpStart, testId: "pricing-dp" },
    { icon: CalendarClock, label: "Cicilan Mulai", value: p.installmentStart, testId: "pricing-installment" },
    { icon: Gift, label: "Promo", value: p.promo, testId: "pricing-promo" },
    { icon: Home, label: "Ketersediaan Unit", value: p.availability, testId: "pricing-availability" },
  ].filter((item) => item.value && !item.value.includes("["));

  return (
    <section className="bg-fade-blue-up py-24" data-testid="pricing-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="bg-navy-texture overflow-hidden rounded-3xl">
          <div className="grid gap-10 p-8 sm:p-12 lg:grid-cols-2 lg:p-16">
            <div>
              <span className="text-xs font-semibold uppercase tracking-[0.2em] text-brand-sky">Harga & Promo</span>
              <h2 className="mt-4 font-display text-3xl font-bold leading-none tracking-tight text-white sm:text-4xl">
                Miliki Rumah Baru Anda di Pontianak
              </h2>
              <p className="mt-4 text-base leading-relaxed text-slate-300">
                Dapatkan informasi harga, skema pembayaran, dan promo terbaru langsung dari tim marketing kami.
              </p>
              <a
                href={cta}
                target={cta.startsWith("http") ? "_blank" : undefined}
                rel="noopener"
                data-testid="pricing-cta-konsultasi"
                className="mt-8 inline-flex items-center gap-2 rounded-full bg-white px-7 py-3.5 text-sm font-semibold text-brand transition-colors duration-200 hover:bg-brand-mist active:scale-95"
              >
                <MessageCircle className="h-4 w-4" />
                Konsultasi Gratis dengan Marketing
              </a>
            </div>
            <div className="grid gap-4 sm:grid-cols-2">
              {items.map((item, i) => (
                <Reveal key={item.label} delay={i * 0.06}>
                  <div className="h-full rounded-2xl border border-white/10 bg-white/5 p-5" data-testid={item.testId}>
                    <item.icon className="h-5 w-5 text-brand-sky" />
                    <p className="mt-3 text-xs uppercase tracking-[0.15em] text-slate-400">{item.label}</p>
                    <p className="mt-1 font-display text-lg font-bold text-white">{item.value}</p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
